export default __webpack_public_path__ + "static/media/zhongjiang.1eccb9ee.png";